import { combineReducers } from 'redux';

import {
    DEBT_LOADING,
    DEBT_LOADED,
} from 'modules/debts/actions/debt.action';

export const loadingDebt = (state = false, action) => {
    switch (action.type) {
        case DEBT_LOADING:
            return action.payload;
        default:
            return state;
    }
};

export const debt = (state = {}, action) => {
    switch (action.type) {
        case DEBT_LOADED:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({
    loadingDebt,
    debt,
});
